import script from "./infoSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./infoSetting.vue?vue&type=script&setup=true&lang=js"

import "./infoSetting.vue?vue&type=style&index=0&id=715f1824&lang=less&scoped=true"
import "./infoSetting.vue?vue&type=style&index=1&id=715f1824&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-715f1824"]])

export default __exports__